import dompurify from 'dompurify';

angular.module('filters').filter('domPurify', function() {
  return function(data) {
    dompurify.addHook('beforeSanitizeElements', function(currentNode) {
      var ref;
      if (((ref = currentNode.tagName) != null ? ref.toLowerCase() : void 0) === 'img') {
        if (!currentNode.getAttribute('alt')) {
          currentNode.setAttribute('alt', ' ');
        }
      }
      return currentNode;
    });
    return dompurify.sanitize(data, {
      ADD_ATTR: ['target', 'alt', 'data-asset-id']
    });
  };
});
